import { useEffect, useState } from "react";
import { ParallaxProvider, Parallax } from "react-scroll-parallax";
import { useInView } from "react-intersection-observer";
import CSR1 from "../../images/CSR1.jpg";
import CSR2 from "../../images/CSR2.jpg";
import CSR3 from "../../images/CSR3.jpg";

const RowCSRdonations = () => {
  const [refFact1, refFact1InView] = useInView();
  const [refFact1isVisible, setrefFact1IsVisible] = useState(false);
  useEffect(() => {
    if (refFact1InView && !refFact1isVisible) {
      setrefFact1IsVisible(true);
    } else if (!refFact1InView && refFact1isVisible) {
      setrefFact1IsVisible(false);
    }
  }, [refFact1isVisible, refFact1InView]);

  return (
    <div className="color-dk-r">
      <div className="row m-0 flex-row-reverse text-center">
        <div className="stickyRowHeaders3 col-lg-4 col-12 d-flex align-items-center justify-content-center ">
          <div className="d-lg-none d-inline">
            <div>Direct Donation to Charities</div>
          </div>
          <div className="d-none d-lg-block">
            <ParallaxProvider>
              <Parallax
                translateY={[-40, 40]}
                opacity={[1, 0.8]}
                easing="easeOut"
                scale={[0.8, 1]}
              >
                <div>Direct Donation to Charities</div>
              </Parallax>
            </ParallaxProvider>
          </div>
        </div>

        <div className="col-lg-8 col-12 text-start color-dk-dark line-height-lg bg-color-w py-2 py-lg-5">
          <div
            ref={refFact1}
            className={
              refFact1isVisible
                ? "fade-in-section is-visible row m-0 text-center py-3 py-lg-5"
                : "fade-in-section row m-0 text-center py-3 py-lg-5"
            }
          >
            <div className="row mx-0 justify-content-center ">
              <div className="col-12 col-lg-4 py-3 ">
                <img
                  className="CSR2coverImages"
                  src={CSR1}
                  alt="The Kind Hand Project"
                />
                <h6 className="dk-medium radius4 bg-color-gr dk-bold py-4">
                  The Kind Hand Project
                </h6>
                <p className="dk-small pt-3 text-start">
                  The Kind Hand is a project planned for supporting vulnerable
                  producers. This project is supported by charity organizations
                  at entrepreneurship centers to help producers with achieving
                  economical independence and production skills. Digikala tries
                  to provide necessary conditions for these producers to be
                  present in the digital atmosphere in the form of holding sales
                  campaigns, discounts in seller’ commissions, support and
                  education.
                </p>
              </div>
              <div className="col-12 col-lg-4 py-3 ">
                <img
                  className="CSR2coverImages"
                  src={CSR2}
                  alt="The Kind Bag Campaign"
                />
                <h6 className="dk-medium radius4 bg-color-gr dk-bold py-4">
                  The Kind Bag Campaign
                </h6>
                <p className="dk-small pt-3 text-start">
                  The Kind Bag campaign was held in October 2021 with
                  participation of 1376 customers of digikalamehr in a 20 day
                  period. In this campaign, Kind Bags including backpacks,
                  stationaries and tablets were prepared for 500 underprivileged
                  students and shipped by Mehre-Giti NGO.
                </p>
              </div>
              <div className="col-12 col-lg-4 py-3">
                <img
                  className="CSR2coverImages"
                  src={CSR3}
                  alt="The Yalda to Kindness Campaign"
                />
                <h6 className="dk-medium radius4 bg-color-gr dk-bold py-4">
                  The Yalda to Kindness Campaign
                </h6>
                <p className="dk-small pt-3 text-start">
                  The Yalda to Kindness campaign was held on the eve of the
                  Yalda night with help of digikalamehr customers to support
                  people who have to live on the streets due to lack of shelter.
                  In this plan, sanitary and heating equipment including warm
                  clothes and some sanitary products were prepared and made
                  available for 800 homeless persons.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RowCSRdonations;
